// lib
import React, { useCallback } from 'react';
import { Form, FormRenderProps } from 'react-final-form';

// src
import { Address } from './types';
import { RenderEditInfoForm } from './RenderEditInfoForm';

export type EditInfoFormProps = {
  is_updating_employee: boolean;
  country?: string;
  preferred_first_name: string;
  preferred_last_name: string;
  personal_email: string;
  phone?: string;
  address?: Address;
  mailing_address_description_placeholder: string;
  is_primary_residence_present: boolean | number;
  primary_residence: Address;
  show_phone: boolean;
  setShowEditForm: (value: boolean) => void;
  onEmployeeSubmit: (values: any) => void;
};

export const EditInfoForm = ({
  country = '',
  preferred_first_name,
  preferred_last_name,
  personal_email,
  phone,
  address,
  onEmployeeSubmit,
  ...renderEditInfoFormProps
}: EditInfoFormProps) => {
  const renderEditInfoForm = useCallback(
    (formRenderProps: FormRenderProps) => (
      <RenderEditInfoForm {...formRenderProps} {...renderEditInfoFormProps} />
    ),
    [renderEditInfoFormProps]
  );

  return (
    <Form
      onSubmit={onEmployeeSubmit}
      initialValues={{
        preferred_first_name,
        preferred_last_name,
        personal_email,
        phone: phone
          ? phone
              .replace(/\D/g, '')
              .substr(phone.replace(/\D/g, '').length - 10)
          : '',
        street: address?.street,
        locality: address?.locality,
        state: address?.state,
        zip: address?.zip,
        country: address?.country?.toUpperCase() || country.toUpperCase() || '',
      }}
      render={renderEditInfoForm}
    />
  );
};
